import { Injectable } from '@angular/core';
import { from, type Observable } from 'rxjs';
import type { AdminUserUserListDto } from '../../../../backend/main';
import { listUsersAsync } from '../../../../backend/main';

import type { DtoListService, GetAllRequestParameters, ListPaginatedDTO } from '@pct/ng-core-dto';
import { UNKNOWN_ITEM } from '@pct/ng-core-dto';
import { isNil } from '@pct/ts-typeguard';
import type { UserFilter } from './user-filter';
import type { FilteredParams } from '../../../common/request/filtered-params';
import { mapSort } from '../../../common/request/map-sort';
import { convertPaginationParams } from '../../../common/utils/table/convert-pagination-params';

@Injectable()
export class UserDtoService implements DtoListService<
  AdminUserUserListDto,
  FilteredParams<AdminUserUserListDto, UserFilter>
> {
  getAll(
    param: GetAllRequestParameters<FilteredParams<AdminUserUserListDto, UserFilter>>,
  ): Observable<ListPaginatedDTO<AdminUserUserListDto>> {
    return from(
      listUsersAsync({
        body: {
          pagination: convertPaginationParams(param.pagination),
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          sort: mapSort(param.parameters?.sort) as any,
          searchText: param.parameters?.filter?.searchText,
        },
      }).then(resp => resp.data),
    );
  }

  getDtoId(dto: AdminUserUserListDto): string;
  getDtoId(dto: AdminUserUserListDto | null | undefined): string | null | undefined;
  getDtoId(dto: Partial<AdminUserUserListDto> | null | undefined): string | null | undefined;
  getDtoId(
    dto: AdminUserUserListDto | Partial<AdminUserUserListDto> | null | undefined,
  ): string | null | undefined {
    if (isNil(dto)) {
      return dto;
    }
    return dto.id;
  }

  toString(dto: AdminUserUserListDto): string {
    return dto.nickName ?? UNKNOWN_ITEM;
  }
}
